import "./css/Register.css";
import { useRef, useState, useEffect } from "react";
import { TextField, FormControl } from "@mui/material";
import { NavLink } from "react-router-dom";

import axios from "../../../lib/axios";

import LoginGoogle from "./LoginGoogle";

import { ButtonLanding } from "../../../components/Buttons";

// Hooks
import useSetTokenState from "../hooks/useSetTokenState";
import PhysioTracker from "../../Landing/components/PhysioTracker";
import LoginGuest from "./LoginAsGuest";
import useManageInput from "../hooks/useManageInput";
import useUserRegister from "../hooks/useUserRegister";
import AuthSectionContainer from "./AuthSectionContainer";

function Register() {
  const userRef = useRef();
  useEffect(() => {
    userRef.current.focus();
  }, []);

  const {
    value: name,
    valueIsValid: nameIsValid,
    error: nameError,
    setValue: setName,
    setError: setNameError,
    showError: showNameError,
  } = useManageInput("name", {
    required: true,
    rule: {
      regex: /^[a-zA-Z0-9\s]+$/,
      message: "Only alphabets, numbers and spaces are allowed.",
    },
  });
  const {
    value: email,
    valueIsValid: emailIsValid,
    error: emailError,
    setValue: setEmail,
    setError: setEmailError,
    showError: showEmailError,
  } = useManageInput("email", {
    required: true,
    rule: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email",
    },
  });
  const {
    value: password,
    valueIsValid: passwordIsValid,
    error: passwordError,
    setValue: setPassword,
    setError: setPasswordError,
    showError: showPasswordError,
  } = useManageInput("password", {
    required: true,
    minChar: 6,
  });

  const {
    value: passConfirm,
    valueIsValid: passConfirmIsValid,
    error: passConfirmError,
    setValue: setPassConfirm,
    setError: setPassConfirmError,
    showError: showPassConfirmError,
  } = useManageInput("confirm password", {
    required: true,
    rule: {
      regex: new RegExp(`${password}`),
      message: "Password does not matched",
    },
  });

  const [registerUser, registering, registerError] = useUserRegister();

  const handleRequestError = (errors) => {
    if (!errors) return;
    setNameError(errors?.name?.[0]);
    setEmailError(errors?.email?.[0]);
    setPasswordError(errors?.password?.[0]);
    setPassConfirmError(errors?.password?.[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    showNameError();
    showEmailError();
    showPasswordError();
    showPassConfirmError();

    if (nameIsValid && emailIsValid && passwordIsValid && passConfirmIsValid) {
      const response = await registerUser(name, email, password, passConfirm);

      handleRequestError(response.errors);
    }
  };

  return (
    <AuthSectionContainer className={"register"} title="Register">
      <form onSubmit={handleSubmit}>
        <FormControl>
          <p className="error-message">{nameError && nameError}</p>
          <TextField
            id="name"
            label="Name"
            variant="outlined"
            size="normal"
            type="text"
            fullWidth
            autoComplete="off"
            inputRef={userRef}
            value={name}
            error={nameError ? true : false}
            onChange={(e) => setName(e.target.value)}
          />
        </FormControl>

        <FormControl>
          <p className="error-message">{emailError && emailError}</p>
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            size="normal"
            type="text"
            fullWidth
            value={email}
            error={emailError ? true : false}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="off"
          />
        </FormControl>
        <FormControl>
          <p className="error-message">{passwordError && passwordError}</p>
          <TextField
            id="password"
            label="Password"
            variant="outlined"
            size="normal"
            type="password"
            fullWidth
            value={password}
            error={passwordError ? true : false}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
          />
        </FormControl>
        <FormControl>
          <p className="error-message">
            {passConfirmError && passConfirmError}
          </p>
          <TextField
            id="password_confirmation"
            label="Confirm password"
            variant="outlined"
            size="normal"
            type="password"
            fullWidth
            value={passConfirm}
            error={passConfirmError ? true : false}
            onChange={(e) => setPassConfirm(e.target.value)}
            autoComplete="off"
          />
        </FormControl>
        <ButtonLanding
          type="submit"
          name="Create account"
          style={{ marginTop: "1rem" }}
          loading={registering}
        />
      </form>
      <div className="register-redirect">
        <p>
          Already have an account?
          <NavLink to={"/login"} className="redirect">
            Login
          </NavLink>
        </p>
      </div>
      <div className="login-hr">
        <div className="line">
          <div></div>
        </div>
        <div className="words">or</div>
        <div className="line">
          <div></div>
        </div>
      </div>
      <div className="login-alt register">
        <LoginGuest />
        <LoginGoogle />
      </div>
    </AuthSectionContainer>
  );
}

export default Register;
